<template>
  <section>
    <Title :title-name="title.OverbookedPassenger.titleName" :title-link="title.OverbookedPassenger.titleLink" />
    <div class="select_manual_service">
      <div class="container" style="margin-top: 14pt">
        <p>Dear {{ pax.title }} {{ pax.first_name }} {{ pax.last_name }} ,</p>
        <div>
          <p>
            We have rebooked you to flight <span v-if="Rebook">{{ Rebook.fight_number }}</span> from
            <span v-if="Rebook">{{ Rebook.from_airport_name }}</span> to <span v-if="Rebook">{{ Rebook.to_airport_name }}</span
            >, which will depart tomorrow on <span v-if="Rebook">{{ moment(Rebook.date).format('DD-MM-YYYY') }}</span> at
            <span v-if="Rebook">{{ moment(Rebook.date).format('HH:mm') }}</span
            >.
          </p>
          <p>
            As your new flight will leave tomorrow we would like to offer you a choice of a taxi transportation to your home with
            maximum amount of 50 {{ airline.currency_code }}
          </p>
          <p>Or you can choose for an accommodation for tonight in a hotel near the airport.</p>
        </div>
      </div>
      <div class="container">
        <div class="block-item">
          <div class="container">
            <h2 class="title sb_mobile sb_creditcard" style="font-size: 16pt; padding-left: 45pt; width: 100%; margin: 0">
              Cash compensation for overbooking
            </h2>
          </div>
        </div>
        <div class="container">
          <div class="block_div">
            <div class="content-section-wrap">
              <div class="description-wrap">
                <p>We have issued a {{ airline.currency_code }} 50 creditcard for your convenience</p>
                <p>This creditcard will be valid until.</p>
                <p>
                  Date <span v-if="Rebook">{{ moment(Rebook.date).format('DD-MM-YYYY') }}</span> time
                  <span v-if="Rebook">{{ moment(Rebook.date).format('HH:mm') }}</span> and it can be used at the food and beverage
                  outlets at the airport.
                </p>
              </div>
              <CreditCard></CreditCard>
            </div>
          </div>
        </div>
      </div>
      <div class="block-item">
        <div class="container">
          <router-link
            style="display: block; padding: 10pt 0; text-transform: uppercase"
            :to="{ name: 'VirtualCreditCardDetail', query: { secret: secret } }"
          >
            <div>
              <AboutCreditCard></AboutCreditCard>
            </div>
          </router-link>
        </div>
      </div>
      <ButtonDownloadVoucher :name-voucher="nameVoucher" :can-download="canDownload"></ButtonDownloadVoucher>
      <div class="container">
        <h2 class="title" style="font-size: 16pt; width: 100%; margin: 0">Select your service</h2>
      </div>
      <div class="container">
        <p>
          We offer you the option to take a taxi voucher of {{ airline.currency_code }} 50,- for transportation to the place of
          your choice
        </p>
        <a class="btnOrange sb_mobile sb_taxi" @click="autoAssignSer(4)">
          Yes, I would like 50 {{ airline.currency_code }} creditcard to use for transportation
        </a>
      </div>
      <div class="container">
        <h2 class="title" style="font-size: 16pt; width: 100%; margin: 0; text-align: center">OR</h2>
      </div>
      <div class="container">
        <p>We offer you the option to for a hotel overnight near the airport</p>
        <a class="btnOrange sb_mobile sb_hotel" @click="autoAssignSer(1)"> Yes, I would like a hotel overnight for tonight </a>
      </div>
    </div>
  </section>
</template>

<script>
import CreditCard from '@/components/CreditCard/index'
import AboutCreditCard from '@/components/AboutCreditCard/index'
import ButtonDownloadVoucher from '@/components/ButtonDownloadVoucher/index'
import Title from '@/components/Title/index'
import { replaceStr } from '@/utils/helper'
import { mapGetters } from 'vuex'

export default {
  name: 'OverbookedPassenger',
  components: { CreditCard, AboutCreditCard, ButtonDownloadVoucher, Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nameVoucher: 'Cash',
      canDownload: false
    }
  },
  computed: {
    ...mapGetters({
      Rebook: 'OverbookedPassenger/Rebook',
      PaxsGroup: 'SelectManualService/PaxsGroup'
    })
  },
  watch: {
    airline: function (newVal) {
      this.canDownload = newVal.fight_number != '' ? true : false
    }
  },
  mounted() {
    this.$store.dispatch('OverbookedPassenger/getRebook')
    this.$store.dispatch('SelectManualService/getPaxsGroup')
  },
  methods: {
    replaceStr,
    autoAssignSer(ser) {
      let dataAssign = {
        service_id: ser,
        pax_ids: _.map(this.PaxsGroup, 'passenger_id')
      }

      this.$store.dispatch('FlightNextDay/assignService', dataAssign).then((response) => {
        if (response.success) {
          window.location.href = '/home?secret=' + this.secret
        }
      })
    }
  }
}
</script>
